"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecordKeys = void 0;
const getRecordKeys = (record) => {
    return Object.keys(record);
};
exports.getRecordKeys = getRecordKeys;
//# sourceMappingURL=utils.js.map